import React from "react";
import Pagination from "react-bootstrap/Pagination";
import { useState } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    Form,
    Button,
    Table,
} from "react-bootstrap";

import { Link } from "react-router-dom";

const supportRequests = [
    {
        id: 1,
        userId: "USR1021",
        name: "Arun Kumar",
        query: "Deposit",
        subject: "Amount Not Credited",
        description: "Deposit completed but amount not reflected.",
        reply: "Checking",
        date: "02 Jun 2026",
        status: "Pending",
    },
    {
        id: 2,
        userId: "USR1022",
        name: "Rahul",
        query: "Withdrawal",
        subject: "Bank Delay",
        description: "Withdrawal taking more time than expected.",
        reply: "Resolved",
        date: "01 Jun 2026",
        status: "Closed",
    },
    {
        id: 3,
        userId: "USR1023",
        name: "Vijay",
        query: "Account",
        subject: "Profile Update",
        description: "Unable to update account details.",
        reply: "In Progress",
        date: "30 May 2026",
        status: "Open",
    },
    {
        id: 4,
        userId: "USR1024",
        name: "Karthik",
        query: "2FA",
        subject: "OTP Issue",
        description: "Authenticator OTP not working.",
        reply: "Resolved",
        date: "29 May 2026",
        status: "Closed",
    },
];

export default function UserSupport() {

    const [currentPage, setCurrentPage] = useState(1);

    const itemsPerPage = 5;

    const totalPages = Math.ceil(
        supportRequests.length / itemsPerPage
    );

    const currentData = supportRequests.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    return (

        <>


            <div className="breadcrumb-bar mb-2 mx-1">
                <div className="container-fluid">
                    <div className="d-flex flex-row flex-md-row align-items-md-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/user/home" className="breadcrumb-link active my-2">
                                Home
                            </Link>

                            <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span>

                            <span
                                className="breadcrumb-link inactive"
                            // onClick={() => navigate("/user/support")}
                            >
                                Support center
                            </span>
                        </div>

                        {/* <button
                            className="add-outlet-btn"
                            onClick={() => navigate("/admin/projects")}
                        >
                            <i className="bi bi-list-ul me-2"></i>
                            Projectlist
                        </button> */}

                    </div>
                </div>
            </div>

            <div className="px-2">

                <Container fluid>



                    <Card className="support-form-card">

                        <div className="support-header d-flex justify-content-between align-items-center mb-4">

                            <div>

                                <h2>
                                    Support Center
                                </h2>

                            </div>

                            <div className="support-icon">

                                <i className="bi bi-headset"></i>

                            </div>

                        </div>



                        <Form>

                            <Row className="g-4">

                                <Col md={6}>

                                    <Form.Group>

                                        <Form.Label>
                                            Query Type
                                        </Form.Label>

                                        <Form.Select className="support-input">

                                            <option>Deposit</option>
                                            <option>Withdrawal</option>
                                            <option>Account</option>
                                            <option>2FA</option>

                                        </Form.Select>

                                    </Form.Group>

                                </Col>

                                <Col md={6}>

                                    <Form.Group>

                                        <Form.Label>
                                            Subject
                                        </Form.Label>

                                        <Form.Control
                                            type="text"
                                            placeholder="Enter Subject"
                                            className="support-input"
                                        />

                                    </Form.Group>

                                </Col>

                                <Col md={12}>

                                    <Form.Group>

                                        <Form.Label>
                                            Message
                                        </Form.Label>

                                        <Form.Control
                                            as="textarea"
                                            rows={6}
                                            placeholder="Write your message here..."
                                            className="support-textarea"
                                        />

                                    </Form.Group>

                                </Col>

                            </Row>

                            <div className="d-flex justify-content-center mt-4">

                                <Button className="send-btn">

                                    <i className="bi bi-send-fill"></i>

                                    Send Support Mail

                                </Button>

                            </div>

                        </Form>

                    </Card>

                    {/* STATS */}

                    <Row className="g-4 mb-4">

                        <Col lg={3} md={6}>

                            <Card className="support-stat-card">

                                <div className="stat-icon sky-bg">

                                    <i className="bi bi-envelope-paper-fill"></i>

                                </div>

                                <h6>Total Tickets</h6>

                                <h3>120</h3>

                            </Card>

                        </Col>

                        <Col lg={3} md={6}>

                            <Card className="support-stat-card">

                                <div className="stat-icon green-bg">

                                    <i className="bi bi-check-circle-fill"></i>

                                </div>

                                <h6>Resolved</h6>

                                <h3>85</h3>

                            </Card>

                        </Col>

                        <Col lg={3} md={6}>

                            <Card className="support-stat-card">

                                <div className="stat-icon orange-bg">

                                    <i className="bi bi-clock-history"></i>

                                </div>

                                <h6>Pending</h6>

                                <h3>20</h3>

                            </Card>

                        </Col>

                        <Col lg={3} md={6}>

                            <Card className="support-stat-card">

                                <div className="stat-icon red-bg">

                                    <i className="bi bi-exclamation-circle-fill"></i>

                                </div>

                                <h6>Open Issues</h6>

                                <h3>15</h3>

                            </Card>

                        </Col>

                    </Row>

                    <Row>
                        <div className="mx-1 my2"><h4>Support </h4></div>
                    </Row>

                    <Card className="ud-table-card mt-4">

                        <div className="ud-scroll-wrap">

                            <Table className="ud-table align-middle mb-0">

                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>USER ID</th>
                                        <th>NAME</th>
                                        <th>QUERY</th>
                                        <th>SUBJECT</th>
                                        <th>DESCRIPTION</th>
                                        <th>REPLY</th>
                                        <th>DATE</th>
                                        <th>STATUS</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {currentData.map((item) => (

                                        <tr key={item.id}>

                                            <td>{item.id}</td>

                                            <td>
                                                <div className="ud-user-cell justify-content-center">

                                                    <div className="ud-avatar">
                                                        <i className="bi bi-person-fill"></i>
                                                    </div>

                                                    <span>{item.userId}</span>

                                                </div>
                                            </td>

                                            <td>{item.name}</td>

                                            <td>
                                                <span className="ud-ref-badge">
                                                    {item.query}
                                                </span>
                                            </td>

                                            <td>{item.subject}</td>

                                            <td>{item.description}</td>

                                            <td>{item.reply}</td>

                                            <td>{item.date}</td>

                                            <td>

                                                <span
                                                    className={`ud-status-badge ${item.status === "Closed"
                                                        ? "ud-status-active"
                                                        : "ud-status-pending"
                                                        }`}
                                                >
                                                    {item.status}
                                                </span>

                                            </td>

                                        </tr>

                                    ))}

                                </tbody>

                            </Table>

                        </div>

                        {totalPages > 1 && (

                            <div className="ud-pagination-wrap">

                                <Pagination className="ud-pagination">

                                    <Pagination.Prev
                                        disabled={currentPage === 1}
                                        onClick={() =>
                                            setCurrentPage((prev) => prev - 1)
                                        }
                                    />

                                    {[...Array(totalPages)].map((_, index) => (

                                        <Pagination.Item
                                            key={index + 1}
                                            active={currentPage === index + 1}
                                            onClick={() =>
                                                setCurrentPage(index + 1)
                                            }
                                        >
                                            {index + 1}
                                        </Pagination.Item>

                                    ))}

                                    <Pagination.Next
                                        disabled={currentPage === totalPages}
                                        onClick={() =>
                                            setCurrentPage((prev) => prev + 1)
                                        }
                                    />

                                </Pagination>

                            </div>

                        )}

                    </Card>



                </Container>

            </div>
        </>

    );
};

